export const Types = {
    FETCH_ORGANIZATIONS: "FETCH_ORGANIZATIONS",
    CLEAN_ORGANIZATION_TREE: "CLEAN_ORGANIZATION_TREE",
    FETCH_ORGANIZATION_TREE: "FETCH_ORGANIZATION_TREE"
  };
  